"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7120],{

/***/ 27120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ve": function() { return /* reexport */ arrow_down; },
  "Y4": function() { return /* reexport */ arrow_left; },
  "LZ": function() { return /* reexport */ arrow_right; },
  "Qu": function() { return /* reexport */ calendar; },
  "yx": function() { return /* reexport */ car; },
  "j9": function() { return /* reexport */ clock; },
  "sH": function() { return /* reexport */ filters; },
  "HL": function() { return /* reexport */ green_brand; },
  "cd": function() { return /* reexport */ green_calendar; },
  "$C": function() { return /* reexport */ green_car; },
  "Mr": function() { return /* reexport */ green_car_2; },
  "iM": function() { return /* reexport */ green_check; },
  "sZ": function() { return /* reexport */ green_click; },
  "zx": function() { return /* reexport */ green_customer; },
  "af": function() { return /* reexport */ green_fuel; },
  "ec": function() { return /* reexport */ green_pocket; },
  "b3": function() { return /* reexport */ green_power; },
  "Tq": function() { return /* reexport */ green_support; },
  "Fe": function() { return /* reexport */ green_transmission; },
  "y_": function() { return /* reexport */ green_upload; },
  "qb": function() { return /* reexport */ grey_car; },
  "P$": function() { return /* reexport */ message; },
  "tm": function() { return /* reexport */ success; }
});

// UNUSED EXPORTS: CommentsIcon, GreenArrowRightIcon, GreenFileIcon, GreyUploadIcon, RedFileIcon

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/comments.tsx


var CommentsIcon = function CommentsIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    children: /*#__PURE__*/_jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        fill: "#656B72",
        children: /*#__PURE__*/_jsx("g", {
          children: /*#__PURE__*/_jsx("g", {
            children: /*#__PURE__*/_jsx("g", {
              children: /*#__PURE__*/_jsx("path", {
                d: "M6.031 14.667c.057 0 .115-.017.167-.057l2.927-2.193H12.5c.827 0 1.5-.673 1.5-1.5v-6.75c0-.828-.673-1.5-1.5-1.5h-9c-.827 0-1.5.672-1.5 1.5v6.75c0 .827.673 1.5 1.5 1.5h2.25v1.968c0 .167.136.282.281.282zm.844-1.97v-1.405H3.5c-.206 0-.375-.17-.375-.375v-6.75c0-.207.169-.375.375-.375h9c.206 0 .375.168.375.375v6.75c0 .206-.169.375-.375.375H8.75l-.3.225-1.575 1.18zM5 8.293c.415 0 .75-.335.75-.75s-.335-.75-.75-.75-.75.335-.75.75.335.75.75.75zm3 0c.415 0 .75-.335.75-.75s-.335-.75-.75-.75-.75.335-.75.75.335.75.75.75zm3 0c.415 0 .75-.335.75-.75s-.335-.75-.75-.75-.75.335-.75.75.335.75.75.75z",
                transform: "translate(-183 -5577) translate(159 5312) translate(24 216) translate(0 49)"
              })
            })
          })
        })
      })
    })
  });
};

/* harmony default export */ var comments = ((/* unused pure expression or super */ null && (CommentsIcon)));
;// CONCATENATED MODULE: ./src/icons/car.tsx


var CarIcon = function CarIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#656B72",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M2.792 12.667c.345 0 .625-.28.625-.625v-.625h9.166v.625c0 .345.28.625.625.625h.417c.345 0 .625-.28.625-.625V8.5c0-.458-.131-.881-.347-1.25h.295c.143 0 .268-.097.303-.236l.156-.625c.05-.198-.1-.389-.303-.389h-1.36l-.816-2.028c-.318-.789-1.083-1.305-1.933-1.305h-4.49c-.85 0-1.616.516-1.933 1.305L3.005 6H1.646c-.203 0-.353.191-.303.388l.156.625c.033.13.169.237.303.237h.295c-.216.369-.347.792-.347 1.25v3.542c0 .345.28.625.625.625h.417zM11.647 6H4.353l.629-1.561c.127-.317.43-.522.773-.522h4.49c.342 0 .646.205.773.522l.629 1.56zm.936 4.167H3.417c-.23 0-.417-.187-.417-.417V8.5c0-.69.56-1.25 1.25-1.25h7.5c.69 0 1.25.56 1.25 1.25v1.25c0 .23-.187.417-.417.417zM5.917 9.12c0-.498-.75-1.246-1.25-1.246s-.834.332-.834.83c0 .5.334.832.834.832.5 0 1.25.083 1.25-.416zm5.416.416c.5 0 .834-.333.834-.831 0-.499-.334-.831-.834-.831-.5 0-1.25.748-1.25 1.246 0 .499.75.416 1.25.416z",
          transform: "translate(-413 -1162) translate(45 818) translate(344 75) translate(24 269)"
        })
      })
    })
  });
};

/* harmony default export */ var car = (CarIcon);
;// CONCATENATED MODULE: ./src/icons/clock.tsx


var ClockIcon = function ClockIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#262626",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.272 12.673c.228-.214.228-.56 0-.773l-1.033-.968c.753-.875 1.203-1.99 1.203-3.201.002-.761-.175-1.483-.491-2.13.542-.468.882-1.137.882-1.883 0-1.41-1.217-2.551-2.722-2.551-1.1 0-2.049.61-2.477 1.492-.42-.046-.848-.046-1.268 0-.428-.882-1.376-1.492-2.477-1.492-1.505 0-2.722 1.141-2.722 2.551 0 .746.34 1.415.882 1.882-.316.648-.493 1.37-.493 2.129 0 1.212.452 2.326 1.203 3.2l-1.033.969c-.229.214-.229.56 0 .772.228.215.598.215.824 0l1.033-.968c1.98 1.497 4.83 1.513 6.83 0l1.035.97c.228.215.598.215.824 0zm-.946-8.045c-.636-.78-1.507-1.381-2.51-1.714.277-.394.753-.654 1.295-.654.858 0 1.556.654 1.556 1.458 0 .345-.13.661-.34.91zm-8.65 0c-.214-.249-.343-.565-.343-.91 0-.804.698-1.458 1.556-1.458.542 0 1.018.26 1.298.654-1.006.333-1.877.934-2.511 1.714zM7 11.738c-2.365 0-4.278-1.793-4.278-4.01 0-2.21 1.906-4.01 4.278-4.01 2.367 0 4.278 1.796 4.278 4.01 0 2.217-1.913 4.01-4.278 4.01zm1.531-2.25l.44-.602c.09-.125.059-.294-.075-.38L7.68 7.721V5.268c0-.15-.132-.274-.292-.274H6.61c-.16 0-.292.123-.292.274V8.25c0 .091.047.176.127.226l1.677 1.082c.134.084.316.052.408-.07z",
          transform: "translate(-413 -1472) translate(45 1377) translate(344 75) translate(16 16) translate(8 4)"
        })
      })
    })
  });
};

/* harmony default export */ var clock = (ClockIcon);
;// CONCATENATED MODULE: ./src/icons/calendar.tsx


var CalendarIcon = function CalendarIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#656B72",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M6.02 8.833H4.98c-.173 0-.313-.14-.313-.312V7.479c0-.172.14-.312.312-.312h1.042c.172 0 .312.14.312.312v1.042c0 .172-.14.312-.312.312zm2.813-.312V7.479c0-.172-.14-.312-.312-.312H7.479c-.172 0-.312.14-.312.312v1.042c0 .172.14.312.312.312h1.042c.172 0 .312-.14.312-.312zm2.5 0V7.479c0-.172-.14-.312-.312-.312H9.979c-.172 0-.312.14-.312.312v1.042c0 .172.14.312.312.312h1.042c.172 0 .312-.14.312-.312zm-2.5 2.5V9.979c0-.172-.14-.312-.312-.312H7.479c-.172 0-.312.14-.312.312v1.042c0 .172.14.312.312.312h1.042c.172 0 .312-.14.312-.312zm-2.5 0V9.979c0-.172-.14-.312-.312-.312H4.979c-.172 0-.312.14-.312.312v1.042c0 .172.14.312.312.312h1.042c.172 0 .312-.14.312-.312zm5 0V9.979c0-.172-.14-.312-.312-.312H9.979c-.172 0-.312.14-.312.312v1.042c0 .172.14.312.312.312h1.042c.172 0 .312-.14.312-.312zm2.5-6.771v9.167c0 .69-.56 1.25-1.25 1.25H3.417c-.69 0-1.25-.56-1.25-1.25V4.25c0-.69.56-1.25 1.25-1.25h1.25V1.646c0-.172.14-.313.312-.313h1.042c.172 0 .312.141.312.313V3h3.334V1.646c0-.172.14-.313.312-.313h1.042c.172 0 .312.141.312.313V3h1.25c.69 0 1.25.56 1.25 1.25zm-1.25 9.01V5.5H3.417v7.76c0 .086.07.157.156.157h8.854c.086 0 .156-.07.156-.157z",
          transform: "translate(-413 -1182) translate(45 818) translate(344 75) translate(24 289)"
        })
      })
    })
  });
};

/* harmony default export */ var calendar = (CalendarIcon);
;// CONCATENATED MODULE: ./src/icons/filters.tsx


var FiltersIcon = function FiltersIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#1B4832",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M8.25 11.25c.98 0 1.814.626 2.122 1.5H16.1c.22 0 .4.18.4.4v.7c0 .22-.18.4-.4.4h-5.728c-.31.874-1.142 1.5-2.122 1.5s-1.813-.626-2.122-1.5H1.9c-.22 0-.4-.18-.4-.4v-.7c0-.22.18-.4.4-.4h4.228c.308-.874 1.142-1.5 2.122-1.5zm0 1.2c-.58 0-1.05.47-1.05 1.05 0 .58.47 1.05 1.05 1.05.58 0 1.05-.47 1.05-1.05 0-.58-.47-1.05-1.05-1.05zm4.5-5.7c.98 0 1.814.626 2.122 1.5H16.1c.22 0 .4.18.4.4v.7c0 .22-.18.4-.4.4h-1.228c-.31.874-1.142 1.5-2.122 1.5s-1.813-.626-2.122-1.5H1.9c-.22 0-.4-.18-.4-.4v-.7c0-.22.18-.4.4-.4h8.728c.308-.874 1.142-1.5 2.122-1.5zm0 1.2c-.58 0-1.05.47-1.05 1.05 0 .58.47 1.05 1.05 1.05.58 0 1.05-.47 1.05-1.05 0-.58-.47-1.05-1.05-1.05zM6 2.25c.98 0 1.814.626 2.122 1.5H16.1c.22 0 .4.18.4.4v.7c0 .22-.18.4-.4.4H8.122c-.31.874-1.142 1.5-2.122 1.5s-1.813-.626-2.122-1.5H1.9c-.22 0-.4-.18-.4-.4v-.7c0-.22.18-.4.4-.4h1.978C4.186 2.877 5.02 2.25 6 2.25zm0 1.2c-.58 0-1.05.47-1.05 1.05 0 .58.47 1.05 1.05 1.05.58 0 1.05-.47 1.05-1.05 0-.58-.47-1.05-1.05-1.05z",
          transform: "translate(-318 -1991) translate(0 1972) translate(187) translate(131 19)"
        })
      })
    })
  });
};

/* harmony default export */ var filters = (FiltersIcon);
;// CONCATENATED MODULE: ./src/icons/message.tsx



var MessageIcon = function MessageIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
          transform: "translate(-275 -3084) translate(275 3084)",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
            cx: "40",
            cy: "40",
            r: "40",
            fill: "#41A476"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            fill: "#FFF",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M22.617 55c.211 0 .43-.062.624-.211l10.978-8.226h12.656c3.102 0 5.625-2.523 5.625-5.625V15.625c0-3.102-2.523-5.625-5.625-5.625h-33.75C10.022 10 7.5 12.523 7.5 15.625v25.313c0 3.102 2.522 5.625 5.625 5.625h8.437v7.382c0 .624.51 1.055 1.055 1.055zm3.164-7.383v-5.273H13.125c-.773 0-1.406-.633-1.406-1.406V15.625c0-.773.633-1.406 1.406-1.406h33.75c.773 0 1.406.633 1.406 1.406v25.313c0 .773-.633 1.406-1.406 1.406H32.812l-1.125.843-5.906 4.43zM18.75 31.094c1.556 0 2.812-1.257 2.812-2.813 0-1.555-1.256-2.812-2.812-2.812-1.556 0-2.813 1.257-2.813 2.812 0 1.556 1.257 2.813 2.813 2.813zm11.25 0c1.556 0 2.812-1.257 2.812-2.813 0-1.555-1.256-2.812-2.812-2.812-1.556 0-2.813 1.257-2.813 2.812 0 1.556 1.257 2.813 2.813 2.813zm11.25 0c1.556 0 2.812-1.257 2.812-2.813 0-1.555-1.256-2.812-2.812-2.812-1.556 0-2.813 1.257-2.813 2.812 0 1.556 1.257 2.813 2.813 2.813z",
              transform: "translate(10 10)"
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ var message = (MessageIcon);
;// CONCATENATED MODULE: ./src/icons/arrow_right.tsx


var ArrowRightIcon = function ArrowRightIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#262626",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M9.603 3.75c.207 0 .374.168.374.374v7.36l2.718-2.69c.138-.137.36-.137.498 0l.58.58c.138.138.138.36 0 .498l-4.336 4.301c-.137.138-.36.138-.498 0l-4.336-4.3c-.137-.138-.137-.36 0-.499l.58-.58c.138-.137.36-.137.498 0l2.718 2.69v-7.36c0-.18.129-.331.3-.366l.075-.008z",
          transform: "translate(-1377 -1392) translate(45 1377) translate(1146 14) translate(186 1) rotate(-90 9.188 9.013)"
        })
      })
    })
  });
};

/* harmony default export */ var arrow_right = (ArrowRightIcon);
;// CONCATENATED MODULE: ./src/icons/arrow_left.tsx


var ArrowLeftIcon = function ArrowLeftIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#262626",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.804 5c.275 0 .499.224.499.499v9.813l3.624-3.586c.183-.184.48-.184.664 0l.773.773c.184.184.184.48 0 .664l-5.781 5.735c-.184.183-.48.183-.664 0l-5.781-5.735c-.184-.183-.184-.48 0-.664l.773-.773c.184-.184.48-.184.664 0l3.623 3.587.001-9.814c0-.245.177-.449.41-.49l.09-.009z",
          transform: "translate(-48 -331) translate(45 328) matrix(-1 0 0 1 23 0) rotate(-90 11.251 12.018)"
        })
      })
    })
  });
};

/* harmony default export */ var arrow_left = (ArrowLeftIcon);
;// CONCATENATED MODULE: ./src/icons/arrow_down.tsx


var ArrowDownIcon = function ArrowDownIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#2EC58D",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M15.557 20.781L7.85 13.135c-.245-.244-.245-.64 0-.885l1.031-1.031c.245-.245.64-.245.886 0L16 17.39l6.234-6.172c.245-.245.641-.245.886 0l1.031 1.031c.245.245.245.64 0 .885l-7.708 7.646c-.245.245-.64.245-.886 0z",
          transform: "translate(-708 -794) translate(708 794)"
        })
      })
    })
  });
};

/* harmony default export */ var arrow_down = (ArrowDownIcon);
;// CONCATENATED MODULE: ./src/icons/success.tsx


var SuccessIcon = function SuccessIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M9 1.5c4.142 0 7.5 3.358 7.5 7.5 0 4.142-3.358 7.5-7.5 7.5-4.142 0-7.5-3.358-7.5-7.5 0-4.142 3.358-7.5 7.5-7.5zm0 1.452C5.657 2.952 2.952 5.657 2.952 9S5.657 15.048 9 15.048 15.048 12.343 15.048 9 12.343 2.952 9 2.952zm4.24 3.94c.141.141.14.371-.002.512l-5.22 5.178c-.142.141-.371.14-.513-.002L4.76 9.812c-.141-.142-.14-.372.002-.513l.687-.682c.142-.14.372-.14.513.003l1.809 1.822 4.274-4.24c.143-.141.372-.14.514.002l.681.687z",
          transform: "translate(-86 -2134) translate(0 1936) translate(86 96) translate(0 99) translate(0 3)"
        })
      })
    })
  });
};

/* harmony default export */ var success = (SuccessIcon);
;// CONCATENATED MODULE: ./src/icons/green_car.tsx



var GreenCarIcon = function GreenCarIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(-277 -2666) translate(160 2566) translate(0 100) translate(117)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: "40",
          cy: "40",
          r: "40",
          fill: "#DFF5EB"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          fill: "#41A476",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M10.468 47.5c1.294 0 2.344-1.05 2.344-2.344v-2.343h34.375v2.343c0 1.294 1.05 2.344 2.344 2.344h1.562c1.294 0 2.344-1.05 2.344-2.344V31.875c0-1.718-.492-3.305-1.3-4.687h1.105c.538 0 1.007-.366 1.137-.887l.586-2.344c.184-.74-.375-1.456-1.138-1.456h-5.099l-3.062-7.605C44.476 11.937 41.607 10 38.42 10H21.58c-3.188 0-6.057 1.937-7.247 4.895L11.27 22.5H6.172c-.762 0-1.322.717-1.136 1.456l.586 2.344c.122.49.632.887 1.136.888h1.105c-.809 1.382-1.3 2.97-1.3 4.686v13.282c0 1.294 1.049 2.344 2.343 2.344h1.562zm33.207-25h-27.35l2.356-5.855c.479-1.189 1.617-1.957 2.899-1.957h16.84c1.282 0 2.42.768 2.898 1.957l2.357 5.854zm3.512 15.625H12.812c-.861 0-1.562-.701-1.562-1.562v-4.688c0-2.585 2.102-4.687 4.687-4.687h28.125c2.585 0 4.688 2.102 4.688 4.687v4.688c0 .86-.701 1.562-1.563 1.562zm-25-3.92c0-1.87-2.812-4.675-4.687-4.675-1.875 0-3.125 1.246-3.125 3.117 0 1.87 1.25 3.116 3.125 3.116s4.687.311 4.687-1.559zM42.5 35.762c1.875 0 3.125-1.246 3.125-3.116s-1.25-3.117-3.125-3.117-4.688 2.805-4.688 4.674c0 1.87 2.813 1.559 4.688 1.559z",
            transform: "translate(10 10)"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var green_car = (GreenCarIcon);
;// CONCATENATED MODULE: ./src/icons/green_car_2.tsx



var green_car_2_GreenCarIcon = function GreenCarIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "33",
    height: "32",
    viewBox: "0 0 33 32",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(-1171 -326) translate(974 172) translate(145 146) translate(52.008 8)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: "16",
          cy: "16",
          r: "16",
          fill: "#DFF5EB"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          fill: "#41A476",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M4.187 19c.518 0 .938-.42.938-.937v-.938h13.75v.938c0 .517.42.937.937.937h.625c.518 0 .938-.42.938-.937V12.75c0-.687-.197-1.322-.52-1.875h.442c.215 0 .402-.146.454-.355l.235-.937c.074-.296-.15-.583-.455-.583h-2.04l-1.225-3.042C17.791 4.775 16.643 4 15.368 4H8.632c-1.275 0-2.423.775-2.899 1.958L4.508 9H2.47c-.305 0-.529.287-.455.582l.235.938c.049.196.252.355.454.355h.442c-.323.553-.52 1.188-.52 1.875v5.313c0 .517.42.937.937.937h.625zM17.47 9H6.53l.943-2.342c.19-.476.646-.783 1.159-.783h6.736c.513 0 .968.307 1.16.783L17.47 9zm1.405 6.25H5.125c-.345 0-.625-.28-.625-.625V12.75c0-1.034.84-1.875 1.875-1.875h11.25c1.034 0 1.875.841 1.875 1.875v1.875c0 .345-.28.625-.625.625zm-10-1.568c0-.748-1.125-1.87-1.875-1.87s-1.25.499-1.25 1.247c0 .748.5 1.246 1.25 1.246s1.875.125 1.875-.623zm8.125.623c.75 0 1.25-.498 1.25-1.246s-.5-1.247-1.25-1.247-1.875 1.122-1.875 1.87 1.125.623 1.875.623z",
            transform: "translate(4 4)"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var green_car_2 = (green_car_2_GreenCarIcon);
;// CONCATENATED MODULE: ./src/icons/green_click.tsx



var GreenClickIcon = function GreenClickIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        id: "j7cczu7vbb",
        d: "M0 0.22L11.433 0.22 11.433 4.167 0 4.167z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        id: "xzcebcwtwd",
        d: "M0.517 0.463L31.653 0.463 31.653 31.579 0.517 31.579z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        id: "vgq0d26i8f",
        d: "M0.589 0.35L4.536 0.35 4.536 11.782 0.589 11.782z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("filter", {
        id: "ppl26g0uja",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          in: "SourceGraphic",
          values: "0 0 0 0 0.254902 0 0 0 0 0.643137 0 0 0 0 0.462745 0 0 0 1.000000 0"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(-680 -2666) translate(160 2566) translate(0 100) translate(403) translate(117)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: "40",
          cy: "40",
          r: "40",
          fill: "#DFF5EB"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          filter: "url(#ppl26g0uja)",
          transform: "translate(10 10)",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
              transform: "translate(5 5) translate(0 16.876)",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
                id: "xiab0x1u1c",
                fill: "#fff",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
                  xlinkHref: "#j7cczu7vbb"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                fill: "#1D1D1B",
                d: "M9.46.22H1.972C.885.22 0 1.106 0 2.194s.885 1.973 1.973 1.973H9.46c1.088 0 1.974-.885 1.974-1.973S10.547.22 9.459.22",
                mask: "url(#xiab0x1u1c)"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
              transform: "translate(5 5) translate(15.072 16.158)",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
                id: "17b24do8we",
                fill: "#fff",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
                  xlinkHref: "#xzcebcwtwd"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                fill: "#1D1D1B",
                d: "M24.8 12.702l-11.483 11.49L5.965 5.81 24.8 12.702zm6.273 15.503l-8.13-8.11 6.838-6.792c.48-.478.68-1.159.531-1.823-.15-.656-.614-1.189-1.25-1.427L3.162.577c-.73-.26-1.548-.069-2.088.487-.538.556-.704 1.38-.42 2.107l10.105 25.262c.247.623.79 1.072 1.49 1.207.13.017.263.02.394.005.507-.012.984-.214 1.35-.575l6.182-6.175 8.104 8.104c.374.376.882.58 1.4.58.17 0 .34-.022.51-.067.68-.183 1.215-.718 1.397-1.398.182-.68-.014-1.411-.513-1.909z",
                mask: "url(#17b24do8we)"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
              transform: "translate(5 5) translate(15.79 .368)",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
                id: "mtbvni13hg",
                fill: "#fff",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
                  xlinkHref: "#vgq0d26i8f"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                fill: "#1D1D1B",
                d: "M2.566 11.782c1.08-.006 1.964-.89 1.97-1.974V2.323c0-1.088-.886-1.974-1.974-1.974S.59 1.235.59 2.323v7.485c0 1.089.885 1.974 1.977 1.974",
                mask: "url(#mtbvni13hg)"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              fill: "#1D1D1B",
              d: "M7.582 5.233l-.076-.067c-.785-.584-1.862-.513-2.561.172-.7.686-.794 1.76-.225 2.557l6.703 6.717c.365.374.875.588 1.399.588.522 0 1.032-.214 1.388-.578.374-.366.588-.876.588-1.398 0-.524-.214-1.033-.584-1.396L7.582 5.233z",
              transform: "translate(5 5)"
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var green_click = (GreenClickIcon);
;// CONCATENATED MODULE: ./src/icons/green_support.tsx



var GreenSupportIcon = function GreenSupportIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        id: "ha99th8kfb",
        d: "M0 0.425L45 0.425 45 50.727 0 50.727z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        id: "w65j6s05nd",
        d: "M0 51.12L45 51.12 45 0.819 0 0.819z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("filter", {
        id: "vadlqil5za",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          in: "SourceGraphic",
          values: "0 0 0 0 0.254902 0 0 0 0 0.643137 0 0 0 0 0.462745 0 0 0 1.000000 0"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(-1083 -2666) translate(160 2566) translate(0 100) translate(806) translate(117)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: "40",
          cy: "40",
          r: "40",
          fill: "#DFF5EB"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          filter: "url(#vadlqil5za)",
          transform: "translate(10 10)",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
            transform: "translate(7.5 2.5)",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
              transform: "translate(0 .393)",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
                id: "34k0nzljnc",
                fill: "#fff",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
                  xlinkHref: "#ha99th8kfb"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                fill: "#1D1D1B",
                d: "M19.964 34.507c1.298.398 2.644.603 4.008.61.355 0 .711-.016 1.064-.046v1.109c0 1.398-1.137 2.536-2.536 2.536-1.398 0-2.536-1.138-2.536-2.536v-1.673zm13.91-26.338c-.892.172-1.582.342-2.104.475-1.578.446-3.214.651-4.862.618-1.607.043-3.175-.21-4.68-.742-1.328-.485-2.721-.731-4.14-.731h-.007c-1.037 0-1.881.843-1.881 1.882v2.536h-2.127V8.198c.007-2.204 1.806-4.003 4.008-4.01h15.792v3.98zM14.526 24.33c.194-.076.384-.165.57-.263l3.128 3.142c.357.346.828.538 1.33.543h4.826v-3.764h-4.054l-2.575-2.577c.476-.892.73-1.888.738-2.907-.003-.877-.193-1.742-.555-2.534h.146c1.039 0 1.883-.845 1.883-1.882V11.77c.367.091.733.202 1.093.334 1.894.649 3.867.947 5.854.921 1.957.037 3.913-.212 5.793-.734.369-.095.753-.19 1.17-.279v9.444c.034 4.983-3.666 9.224-8.609 9.863-4.824.623-9.37-2.363-10.738-6.988zm.2-5.824c0 1.398-1.137 2.536-2.534 2.536-1.396-.004-2.535-1.143-2.539-2.537 0-1.398 1.139-2.535 2.537-2.535 1.399 0 2.537 1.137 2.537 2.536zM36 37.49L28.8 34.863v-.65c5.292-1.995 8.831-7.086 8.837-12.76V2.307c0-1.038-.845-1.882-1.882-1.882H18.08c-4.285 0-7.772 3.487-7.772 7.773v4.315c-2.692.834-4.493 3.328-4.416 6.172.077 2.863 2.035 5.27 4.794 5.939.596 2.453 1.841 4.695 3.62 6.503.588.57 1.223 1.099 1.893 1.57v2.166L9.004 37.49C3.618 39.436 0 44.592 0 50.318v.41h3.763v-.41c.001-4.147 2.62-7.88 6.521-9.291l6.457-2.352c.977 2.292 3.241 3.806 5.76 3.806 2.517 0 4.78-1.514 5.759-3.806l6.457 2.352c3.9 1.41 6.519 5.144 6.52 9.291v.41H45v-.41C45 44.592 41.383 39.437 36 37.49z",
                mask: "url(#34k0nzljnc)"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
              id: "rcpjm64ane",
              fill: "#fff",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
                xlinkHref: "#w65j6s05nd"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              fill: "#1D1D1B",
              d: "M20.618 19.309L24.382 19.309 24.382 15.545 20.618 15.545zM27.982 19.31L31.745 19.31 31.745 15.546 27.982 15.546z",
              mask: "url(#rcpjm64ane)"
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var green_support = (GreenSupportIcon);
;// CONCATENATED MODULE: ./src/icons/green_customer.tsx



var GreenCustomerIcon = function GreenCustomerIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "70",
    height: "70",
    viewBox: "0 0 70 70",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(-275 -3441) translate(275 3441)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: "35",
          cy: "35",
          r: "35",
          fill: "#DFF5EB"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          fill: "#41A476",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M25.977 28.71c6.113 0 11.074-4.96 11.074-11.073 0-6.114-4.96-11.075-11.074-11.075s-11.075 4.96-11.075 11.075c0 6.114 4.96 11.074 11.075 11.074zm0-3.69c-4.069 0-7.383-3.315-7.383-7.383 0-4.069 3.314-7.383 7.383-7.383 4.068 0 7.382 3.314 7.382 7.383 0 4.068-3.314 7.382-7.382 7.382zm13.535 20.917c2.038 0 3.691-1.653 3.691-3.691v-1.969c0-5.706-4.63-10.336-10.336-10.336-2.207 0-3.268 1.23-6.89 1.23-3.623 0-4.676-1.23-6.891-1.23-5.706 0-10.336 4.63-10.336 10.336v1.969c0 2.038 1.653 3.691 3.691 3.691h27.07zm0-3.691h-27.07v-1.969c0-3.66 2.983-6.644 6.644-6.644 1.123 0 2.945 1.23 6.89 1.23 3.976 0 5.76-1.23 6.891-1.23 3.66 0 6.645 2.984 6.645 6.644v1.969z",
            transform: "translate(8.75 8.75)"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var green_customer = (GreenCustomerIcon);
;// CONCATENATED MODULE: ./src/icons/green_brand.tsx



var GreenBrandIcon = function GreenBrandIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "70",
    height: "70",
    viewBox: "0 0 70 70",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(-565 -3441) translate(565 3441)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: "35",
          cy: "35",
          r: "35",
          fill: "#DFF5EB"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          fill: "#41A476",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M26.806 26.25c.5.007 1.019-.164 1.45-.608l6.746-6.973c2.058-2.126 2.489-6.16-.41-8.634-2.625-2.242-6.09-1.217-7.786.533-1.695-1.75-5.16-2.775-7.78-.533-2.898 2.475-2.467 6.508-.41 8.634l6.741 6.973c.43.444.943.608 1.45.608zm0-3.794l-5.886-6.09c-.895-.917-1.107-2.715.178-3.815.964-.82 2.468-.615 3.37.321l2.338 2.413 2.331-2.42c.903-.936 2.413-1.141 3.37-.321 1.292 1.1 1.074 2.898.185 3.821l-5.886 6.091zm-14.219 21.3c.602 0 1.094-.491 1.094-1.093 0-.513-.177-1.012-.492-1.408l-4.02-5.025c-.622-.772-.957-1.736-.957-2.734v-13.2c0-.793.534-1.524 1.313-1.668 1.046-.205 1.969.595 1.969 1.606v.595l.001.242.002.917.001.358.002.776.004 2.14.002.87.005 1.985.002.65.001.532c0 .52.192 1.012.533 1.408l5.23 6.33c1.21 1.463 3.568-.225 2.317-1.928l-3.383-4.58c-.554-.717-.417-1.75.3-2.303.739-.575 1.764-.397 2.304.3l4.901 6.371c.588.766.91 1.703.91 2.666v5.093c0 .602.492 1.094 1.093 1.094h2.188c.601 0 1.094-.492 1.094-1.094V37.57c0-.964.32-1.9.909-2.666l4.901-6.37c.54-.698 1.565-.869 2.304-.302.718.554.854 1.58.3 2.304l-3.383 4.58c-1.258 1.702 1.107 3.39 2.317 1.928l5.23-6.33c.341-.397.526-.889.533-1.408v-4.042-.438l.001-1.292v-.412l.003-1.134v-.334l.002-1.03v-.39c0-1.011.917-1.811 1.97-1.606.779.15 1.312.875 1.312 1.668v13.2c0 .991-.335 1.955-.957 2.728L40.43 41.24c-.321.404-.492.896-.492 1.408 0 .602.492 1.094 1.094 1.094h1.114c.335 0 .65-.15.855-.417l4.012-5.058c1.08-1.354 1.675-3.05 1.675-4.786V20.405c-.007-2.618-1.976-4.908-4.594-5.079-2.864-.191-5.257 2.085-5.257 4.908v.329l-.002.617v.263l-.002.598-.01 3.389c-2.036-1.354-4.955-1.06-6.616 1.093l-4.909 6.378c-.184.24-.341.506-.492.766-.157-.26-.307-.526-.492-.766l-4.908-6.378c-1.682-2.18-4.608-2.426-6.617-1.093l-.008-3.062-.002-.64v-.287l-.002-.499v-.206l-.002-.502c0-2.823-2.393-5.1-5.257-4.908-2.618.171-4.587 2.461-4.587 5.08v13.09c0 1.73.595 3.432 1.675 4.785l4.013 5.059c.205.26.526.417.854.417h1.114z",
            transform: "translate(8.75 8.75)"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var green_brand = (GreenBrandIcon);
;// CONCATENATED MODULE: ./src/icons/green_pocket.tsx



var GreenPocketIcon = function GreenPocketIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "33",
    height: "32",
    viewBox: "0 0 33 32",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(-1312 -326) translate(974 172) translate(292 146) translate(46.466 8)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: "16",
          cy: "16",
          r: "16",
          fill: "#DFF5EB"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          fill: "#41A476",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M19.5 20.273c1.38 0 2.5-1.105 2.5-2.468V8.552c0-1.363-1.12-2.468-2.5-2.468v-.616C19.5 4.105 18.38 3 17 3H5.75C3.679 3 2 4.657 2 6.701v9.87c0 2.045 1.679 3.702 3.75 3.702H19.5zm0-1.85H5.75c-1.034 0-1.875-.831-1.875-1.852v-9.87c0-1.02.841-1.85 1.875-1.85H17c.345 0 .625.276.625.617V6.7H6.375c-.345 0-.625.276-.625.617 0 .341.28.617.625.617H19.5c.345 0 .625.277.625.617v9.253c0 .34-.28.617-.625.617zm-2.5-4.32c.69 0 1.25-.552 1.25-1.233s-.56-1.234-1.25-1.234-1.25.553-1.25 1.234c0 .681.56 1.234 1.25 1.234z",
            transform: "translate(4 4)"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var green_pocket = (GreenPocketIcon);
;// CONCATENATED MODULE: ./src/icons/green_calendar.tsx



var GreenCalendarIcon = function GreenCalendarIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(-1026 -326) translate(974 172) translate(1 146) translate(51 8)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: "16",
          cy: "16",
          r: "16",
          fill: "#DFF5EB"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          fill: "#41A476",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M9.031 13.25H7.47c-.258 0-.469-.21-.469-.469V11.22c0-.258.21-.469.469-.469H9.03c.258 0 .469.21.469.469v1.562c0 .258-.21.469-.469.469zm4.219-.469V11.22c0-.258-.21-.469-.469-.469H11.22c-.258 0-.469.21-.469.469v1.562c0 .258.21.469.469.469h1.562c.258 0 .469-.21.469-.469zm3.75 0V11.22c0-.258-.21-.469-.469-.469H14.97c-.258 0-.469.21-.469.469v1.562c0 .258.21.469.469.469h1.562c.258 0 .469-.21.469-.469zm-3.75 3.75V14.97c0-.258-.21-.469-.469-.469H11.22c-.258 0-.469.21-.469.469v1.562c0 .258.21.469.469.469h1.562c.258 0 .469-.21.469-.469zm-3.75 0V14.97c0-.258-.21-.469-.469-.469H7.47c-.258 0-.469.21-.469.469v1.562c0 .258.21.469.469.469H9.03c.258 0 .469-.21.469-.469zm7.5 0V14.97c0-.258-.21-.469-.469-.469H14.97c-.258 0-.469.21-.469.469v1.562c0 .258.21.469.469.469h1.562c.258 0 .469-.21.469-.469zm3.75-10.156v13.75c0 1.035-.84 1.875-1.875 1.875H5.125c-1.035 0-1.875-.84-1.875-1.875V6.375c0-1.035.84-1.875 1.875-1.875H7V2.469C7 2.21 7.21 2 7.469 2H9.03c.258 0 .469.21.469.469V4.5h5V2.469c0-.258.21-.469.469-.469h1.562c.258 0 .469.21.469.469V4.5h1.875c1.035 0 1.875.84 1.875 1.875zm-1.875 13.516V8.25H5.125v11.64c0 .13.105.235.234.235h13.282c.129 0 .234-.105.234-.234z",
            transform: "translate(4 4)"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var green_calendar = (GreenCalendarIcon);
;// CONCATENATED MODULE: ./src/icons/green_file.tsx


var GreenFileIcon = function GreenFileIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/_jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        fill: "#41A476",
        children: /*#__PURE__*/_jsx("g", {
          children: /*#__PURE__*/_jsx("g", {
            children: /*#__PURE__*/_jsx("g", {
              children: /*#__PURE__*/_jsx("path", {
                d: "M18.125 22C19.161 22 20 21.16 20 20.125V7.152c0-.43-.246-1.023-.55-1.326l-3.276-3.277C15.871 2.246 15.277 2 14.848 2H6.875C5.839 2 5 2.84 5 3.875v16.25C5 21.161 5.84 22 6.875 22h11.25zm0-1.875H6.875V3.875h6.25v4.063c0 .517.42.937.938.937h4.062v11.25zM17.973 7H15V4.027L17.973 7zm-6.456 11.114l5.56-5.515c.183-.182.184-.479.002-.663l-.88-.887c-.183-.184-.48-.185-.663-.003l-4.34 4.304-1.722-1.737c-.182-.183-.479-.185-.663-.002l-.887.88c-.184.182-.185.48-.003.663l2.933 2.957c.183.184.48.185.663.003z",
                transform: "translate(-221 -563) translate(160 496) translate(53 56) translate(8 11)"
              })
            })
          })
        })
      })
    })
  });
};

/* harmony default export */ var green_file = ((/* unused pure expression or super */ null && (GreenFileIcon)));
;// CONCATENATED MODULE: ./src/icons/green_fuel.tsx


var GreenFuelIcon = function GreenFuelIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.578 17.5c.129 0 .235-.105.235-.234v-.938c0-.129-.106-.234-.235-.234h-.703v-4.688h.234c.648 0 1.172.525 1.172 1.172v.815c0 1.104.791 2.109 1.89 2.223 1.26.126 2.329-.864 2.329-2.1V6.97c0-.498-.196-.976-.548-1.327l-2.537-2.538c-.09-.09-.24-.09-.331 0l-.662.663c-.09.09-.09.24 0 .33l1.265 1.27v1.819c0 .823.613 1.502 1.407 1.617v4.71c0 .387-.317.704-.703.704-.387 0-.704-.317-.704-.703v-.938c0-1.424-1.154-2.578-2.578-2.578h-.234V3.906c0-.776-.63-1.406-1.406-1.406H4.844c-.777 0-1.407.63-1.407 1.406v12.188h-.703c-.129 0-.234.105-.234.234v.938c0 .129.105.234.234.234h9.844zm-2.11-9.375H4.845V3.906h5.625v4.219zm0 7.969H4.845V9.53h5.625v6.563z",
          transform: "translate(-975 -440) translate(974 172) translate(1 268)"
        })
      })
    })
  });
};

/* harmony default export */ var green_fuel = (GreenFuelIcon);
;// CONCATENATED MODULE: ./src/icons/green_transmission.tsx


var GreenTransmissionIcon = function GreenTransmissionIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M6.457 17.48h7.693v-.694H6.457v.694zm2.408-5.944h2.878c.256 0 .49.132.582.33l1.153 2.527.555 1.216H6.578l.554-1.216 1.154-2.528c.09-.198.322-.33.579-.33zm1.859-5.116l-.001.001c-.042.117-.219.202-.421.202-.083 0-.166-.014-.234-.04-.066-.028-.15-.077-.182-.157l-.005-.011c-.482-1.304-.716-2.222-.716-2.804 0-.423.51-.768 1.137-.768.628 0 1.14.343 1.14.765 0 .574-.235 1.493-.718 2.812zm.095 1.373v2.566h-.963V7.793c.185.005.4.006.485.006.084 0 .296 0 .478-.006zm4.704 7.706c-.013-.03-1.32-2.9-1.843-4.045-.288-.634-1.023-1.067-1.847-1.096V7.196c.13-.14.223-.289.274-.442.52-1.415.783-2.473.783-3.146 0-1.07-1.161-1.941-2.588-1.941-1.426 0-2.585.87-2.585 1.941 0 .473.135 1.403.78 3.148.06.159.15.306.273.44v3.165c-.82.03-1.555.463-1.846 1.095-.523 1.156-1.813 3.977-1.842 4.04l-.002.003c-.071.158-.095.79-.071 1.877v.003c.001.526.529.954 1.177.954h8.236c.648 0 1.175-.428 1.176-.954.013-.611.021-1.667-.075-1.88z",
          transform: "translate(-975 -468) translate(974 172) translate(1 296)"
        })
      })
    })
  });
};

/* harmony default export */ var green_transmission = (GreenTransmissionIcon);
;// CONCATENATED MODULE: ./src/icons/green_power.tsx


var GreenPowerIcon = function GreenPowerIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M16.505 16c.307 0 .6-.158.755-.43.682-1.203 1.073-2.601 1.073-4.094 0-4.497-3.544-8.143-7.916-8.143-4.373 0-7.917 3.646-7.917 8.143 0 1.493.392 2.891 1.074 4.094.154.272.448.43.754.43h12.177zm-.253-1.357H4.582c-.5-.972-.763-2.06-.763-3.167 0-3.742 2.96-6.786 6.598-6.786 3.637 0 6.597 3.044 6.597 6.786 0 1.106-.263 2.195-.762 3.167zM10.27 7.827l.446-1.378c.032-.097.087-.18.135-.266-.13-.078-.273-.135-.434-.135-.486 0-.88.405-.88.904 0 .447.32.8.733.875zm1.662 5.459c.151-.267.244-.574.244-.905 0-.55-.243-1.037-.62-1.369l1.247-3.845c.114-.355-.073-.74-.418-.858-.35-.12-.72.074-.836.429l-1.246 3.845c-.917.061-1.646.838-1.646 1.798 0 .331.093.638.245.905h3.03zM7.338 9.214c.486 0 .88-.405.88-.904 0-.5-.394-.905-.88-.905s-.88.405-.88.905.394.904.88.904zm6.157 0c.486 0 .88-.405.88-.904 0-.447-.32-.801-.734-.875l-.004.018-.536 1.654c.12.063.25.108.394.108zM6.02 12.382c.485 0 .88-.405.88-.905s-.395-.905-.88-.905c-.486 0-.88.406-.88.905 0 .5.394.905.88.905zm8.796 0c.486 0 .88-.405.88-.905s-.394-.905-.88-.905-.88.406-.88.905c0 .5.394.905.88.905z",
          transform: "translate(-975 -496) translate(974 172) translate(1 324)"
        })
      })
    })
  });
};

/* harmony default export */ var green_power = (GreenPowerIcon);
;// CONCATENATED MODULE: ./src/icons/green_check.tsx


var GreenCheckIcon = function GreenCheckIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M6.617 13.9L2.438 9.72c-.25-.25-.25-.657 0-.908l.91-.91c.25-.25.658-.25.909 0l2.814 2.815 6.03-6.029c.25-.25.658-.25.909 0l.909.91c.25.25.25.658 0 .909l-7.393 7.392c-.251.251-.658.251-.91 0z",
          transform: "translate(-975 -644) translate(974 172) translate(1 472)"
        })
      })
    })
  });
};

/* harmony default export */ var green_check = (GreenCheckIcon);
;// CONCATENATED MODULE: ./src/icons/green_arrow_right.tsx


var GreenArrowRightIcon = function GreenArrowRightIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    children: /*#__PURE__*/_jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        fill: "#41A476",
        children: /*#__PURE__*/_jsx("g", {
          children: /*#__PURE__*/_jsx("g", {
            children: /*#__PURE__*/_jsx("g", {
              children: /*#__PURE__*/_jsx("path", {
                d: "M9.603 3.75c.207 0 .374.168.374.374v7.36l2.718-2.69c.138-.137.36-.137.498 0l.58.58c.138.138.138.36 0 .498l-4.336 4.301c-.137.138-.36.138-.498 0l-4.336-4.3c-.137-.138-.137-.36 0-.499l.58-.58c.138-.137.36-.137.498 0l2.718 2.69v-7.36c0-.18.129-.331.3-.366l.075-.008z",
                transform: "translate(-1377 -1392) translate(45 1377) translate(1146 14) translate(186 1) rotate(-90 9.188 9.013)"
              })
            })
          })
        })
      })
    })
  });
};

/* harmony default export */ var green_arrow_right = ((/* unused pure expression or super */ null && (GreenArrowRightIcon)));
;// CONCATENATED MODULE: ./src/icons/green_upload.tsx


var GreenUploadIcon = function GreenUploadIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "41",
    height: "40",
    viewBox: "0 0 41 40",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M31.7 7.667c.442 0 .8.358.8.8v1.4c0 .441-.358.8-.8.8H21.413l9.194 9.12c.306.306.306.8 0 1.107l-1.289 1.289c-.306.306-.8.306-1.107 0l-6.038-5.979-.002 16.357c0 .423-.317.773-.727.825l-.104.006h-1.843c-.424 0-.774-.317-.825-.727l-.007-.104V16.203l-6.04 5.98c-.306.306-.8.306-1.106 0l-1.29-1.29c-.305-.305-.305-.8 0-1.106l9.193-9.12H9.133c-.441 0-.8-.359-.8-.8v-1.4c0-.442.359-.8.8-.8H31.7z",
          transform: "translate(-395 -717) translate(160 709) translate(235.743 8)"
        })
      })
    })
  });
};

/* harmony default export */ var green_upload = (GreenUploadIcon);
;// CONCATENATED MODULE: ./src/icons/grey_upload.tsx


var GreyUploadIcon = function GreyUploadIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "41",
    height: "40",
    viewBox: "0 0 41 40",
    children: /*#__PURE__*/_jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        fill: "#656b72",
        children: /*#__PURE__*/_jsx("g", {
          children: /*#__PURE__*/_jsx("g", {
            children: /*#__PURE__*/_jsx("path", {
              d: "M31.7 7.667c.442 0 .8.358.8.8v1.4c0 .441-.358.8-.8.8H21.413l9.194 9.12c.306.306.306.8 0 1.107l-1.289 1.289c-.306.306-.8.306-1.107 0l-6.038-5.979-.002 16.357c0 .423-.317.773-.727.825l-.104.006h-1.843c-.424 0-.774-.317-.825-.727l-.007-.104V16.203l-6.04 5.98c-.306.306-.8.306-1.106 0l-1.29-1.29c-.305-.305-.305-.8 0-1.106l9.193-9.12H9.133c-.441 0-.8-.359-.8-.8v-1.4c0-.442.359-.8.8-.8H31.7z",
              transform: "translate(-395 -717) translate(160 709) translate(235.743 8)"
            })
          })
        })
      })
    })
  });
};

/* harmony default export */ var grey_upload = ((/* unused pure expression or super */ null && (GreyUploadIcon)));
;// CONCATENATED MODULE: ./src/icons/red_file.tsx


var RedFileIcon = function RedFileIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/_jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        fill: "#de0000",
        children: /*#__PURE__*/_jsx("g", {
          children: /*#__PURE__*/_jsx("g", {
            children: /*#__PURE__*/_jsx("g", {
              children: /*#__PURE__*/_jsx("path", {
                d: "M18.125 22C19.161 22 20 21.16 20 20.125V7.152c0-.43-.246-1.023-.55-1.326l-3.276-3.277C15.871 2.246 15.277 2 14.848 2H6.875C5.839 2 5 2.84 5 3.875v16.25C5 21.161 5.84 22 6.875 22h11.25zm0-1.875H6.875V3.875h6.25v4.063c0 .517.42.937.938.937h4.062v11.25zM17.973 7H15V4.027L17.973 7zm-6.456 11.114l5.56-5.515c.183-.182.184-.479.002-.663l-.88-.887c-.183-.184-.48-.185-.663-.003l-4.34 4.304-1.722-1.737c-.182-.183-.479-.185-.663-.002l-.887.88c-.184.182-.185.48-.003.663l2.933 2.957c.183.184.48.185.663.003z",
                transform: "translate(-221 -563) translate(160 496) translate(53 56) translate(8 11)"
              })
            })
          })
        })
      })
    })
  });
};

/* harmony default export */ var red_file = ((/* unused pure expression or super */ null && (RedFileIcon)));
;// CONCATENATED MODULE: ./src/icons/grey_car.tsx



var GreyCarIcon = function GreyCarIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(-334 -1489) translate(334 1489)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: "16",
          cy: "16",
          r: "16",
          fill: "#C1C7CF"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          fill: "#464B52",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M4.187 19c.518 0 .938-.42.938-.937v-.938h13.75v.938c0 .517.42.937.937.937h.625c.518 0 .938-.42.938-.937V12.75c0-.687-.197-1.322-.52-1.875h.442c.215 0 .402-.146.454-.355l.235-.937c.074-.296-.15-.583-.455-.583h-2.04l-1.225-3.042C17.791 4.775 16.643 4 15.368 4H8.632c-1.275 0-2.423.775-2.899 1.958L4.508 9H2.47c-.305 0-.529.287-.455.582l.235.938c.049.196.252.355.454.355h.442c-.323.553-.52 1.188-.52 1.875v5.313c0 .517.42.937.937.937h.625zM17.47 9H6.53l.943-2.342c.19-.476.646-.783 1.159-.783h6.736c.513 0 .968.307 1.16.783L17.47 9zm1.405 6.25H5.125c-.345 0-.625-.28-.625-.625V12.75c0-1.034.84-1.875 1.875-1.875h11.25c1.034 0 1.875.841 1.875 1.875v1.875c0 .345-.28.625-.625.625zm-10-1.568c0-.748-1.125-1.87-1.875-1.87s-1.25.499-1.25 1.247c0 .748.5 1.246 1.25 1.246s1.875.125 1.875-.623zm8.125.623c.75 0 1.25-.498 1.25-1.246s-.5-1.247-1.25-1.247-1.875 1.122-1.875 1.87 1.125.623 1.875.623z",
            transform: "translate(4 4)"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var grey_car = (GreyCarIcon);
;// CONCATENATED MODULE: ./src/icons/index.tsx









 // Green icons

















 // Grey icons



/***/ })

}]);